import SplashScreen from 'components/SplashScreen';
import React, { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { walletRequestsStatus } from 'redux/slice/walletRequestStepOne';
import { clearDocumentList } from 'redux/slice/walletRequestStepTwo';

const WalletRequestPage = React.lazy(() => import('pages/WalletMehr-NewFlow/index'));

const WalletProtectedRoutes = ({ children }) => {
	const { walletStep, redirectToFirst } = useSelector((state) => state.walletRequestOne);
	const { token } = useSelector((state) => state.login);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useLayoutEffect(() => {
		dispatch(walletRequestsStatus({ token }));
	}, []);

	useEffect(() => {
		redirectToFirst && navigate('/walletrequest/addfacilitybankmehr');
		return () => {
			dispatch(clearDocumentList());
		};
	}, [redirectToFirst]);

	return (
		<>
			{walletStep === 1 ? (
				<React.Suspense fallback={<SplashScreen />}>
					<WalletRequestPage />
				</React.Suspense>
			) : (
				children
			)}
		</>
	);
};

export default WalletProtectedRoutes;
